import { __assign, __extends } from "tslib";
import { TransportType } from '@amplitude/analytics-types';
import { Config } from '@amplitude/analytics-core';
import { CookieStorage } from './storage/cookie';
import { FetchTransport } from './transports/fetch';
import { LocalStorage } from './storage/local-storage';
import { MemoryStorage } from './storage/memory';
import { getCookieName } from './session-manager';
import { getQueryParams } from './utils/query-params';
import { UUID } from './utils/uuid';
import { XHRTransport } from './transports/xhr';
import { SendBeaconTransport } from './transports/send-beacon';
export var getDefaultConfig = function getDefaultConfig() {
  return {
    cookieExpiration: 365,
    cookieSameSite: 'Lax',
    cookieSecure: false,
    cookieStorage: new MemoryStorage(),
    disableCookies: false,
    domain: '',
    includeGclid: true,
    includeFbclid: true,
    includeReferrer: true,
    includeUtm: true,
    sessionTimeout: 30 * 60 * 1000,
    storageProvider: new MemoryStorage(),
    trackingOptions: {
      city: true,
      country: true,
      carrier: true,
      deviceManufacturer: true,
      deviceModel: true,
      dma: true,
      ipAddress: true,
      language: true,
      osName: true,
      osVersion: true,
      platform: true,
      region: true,
      versionName: true
    },
    transportProvider: new FetchTransport()
  };
};

var BrowserConfig =
/** @class */
function (_super) {
  __extends(BrowserConfig, _super);

  function BrowserConfig(apiKey, userId, options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;

    var _this = this;

    var defaultConfig = getDefaultConfig();
    _this = _super.call(this, __assign(__assign({}, options), {
      apiKey: apiKey,
      userId: userId,
      optOut: Boolean(options === null || options === void 0 ? void 0 : options.optOut),
      storageProvider: (_a = options === null || options === void 0 ? void 0 : options.storageProvider) !== null && _a !== void 0 ? _a : defaultConfig.storageProvider,
      transportProvider: (_b = options === null || options === void 0 ? void 0 : options.transportProvider) !== null && _b !== void 0 ? _b : defaultConfig.transportProvider
    })) || this;
    _this.cookieExpiration = (_c = options === null || options === void 0 ? void 0 : options.cookieExpiration) !== null && _c !== void 0 ? _c : defaultConfig.cookieExpiration;
    _this.cookieSameSite = (_d = options === null || options === void 0 ? void 0 : options.cookieSameSite) !== null && _d !== void 0 ? _d : defaultConfig.cookieSameSite;
    _this.cookieSecure = (_e = options === null || options === void 0 ? void 0 : options.cookieSecure) !== null && _e !== void 0 ? _e : defaultConfig.cookieSecure;
    _this.cookieStorage = (_f = options === null || options === void 0 ? void 0 : options.cookieStorage) !== null && _f !== void 0 ? _f : defaultConfig.cookieStorage;
    _this.disableCookies = (_g = options === null || options === void 0 ? void 0 : options.disableCookies) !== null && _g !== void 0 ? _g : defaultConfig.disableCookies;
    _this.domain = (_h = options === null || options === void 0 ? void 0 : options.domain) !== null && _h !== void 0 ? _h : defaultConfig.domain;
    _this.includeGclid = (_j = options === null || options === void 0 ? void 0 : options.includeGclid) !== null && _j !== void 0 ? _j : defaultConfig.includeGclid;
    _this.includeFbclid = (_k = options === null || options === void 0 ? void 0 : options.includeFbclid) !== null && _k !== void 0 ? _k : defaultConfig.includeFbclid;
    _this.includeReferrer = (_l = options === null || options === void 0 ? void 0 : options.includeReferrer) !== null && _l !== void 0 ? _l : defaultConfig.includeReferrer;
    _this.includeUtm = (_m = options === null || options === void 0 ? void 0 : options.includeUtm) !== null && _m !== void 0 ? _m : defaultConfig.includeUtm;
    _this.sessionTimeout = (_o = options === null || options === void 0 ? void 0 : options.sessionTimeout) !== null && _o !== void 0 ? _o : defaultConfig.sessionTimeout;
    _this.trackingOptions = (_p = options === null || options === void 0 ? void 0 : options.trackingOptions) !== null && _p !== void 0 ? _p : defaultConfig.trackingOptions;
    return _this;
  }

  return BrowserConfig;
}(Config);

export { BrowserConfig };
export var useBrowserConfig = function useBrowserConfig(apiKey, userId, options) {
  var _a, _b, _c;

  var defaultConfig = getDefaultConfig();
  var cookieStorage = createCookieStorage(options);
  var cookieName = getCookieName(apiKey);
  var cookies = cookieStorage.get(cookieName);
  var queryParams = getQueryParams();
  var sessionTimeout = (_a = options === null || options === void 0 ? void 0 : options.sessionTimeout) !== null && _a !== void 0 ? _a : defaultConfig.sessionTimeout;
  return new BrowserConfig(apiKey, userId !== null && userId !== void 0 ? userId : cookies === null || cookies === void 0 ? void 0 : cookies.userId, __assign(__assign({}, options), {
    cookieStorage: cookieStorage,
    sessionTimeout: sessionTimeout,
    deviceId: createDeviceId(cookies === null || cookies === void 0 ? void 0 : cookies.deviceId, options === null || options === void 0 ? void 0 : options.deviceId, queryParams.deviceId),
    optOut: (_b = options === null || options === void 0 ? void 0 : options.optOut) !== null && _b !== void 0 ? _b : Boolean(cookies === null || cookies === void 0 ? void 0 : cookies.optOut),
    sessionId: createSessionId(cookies === null || cookies === void 0 ? void 0 : cookies.sessionId, options === null || options === void 0 ? void 0 : options.sessionId, cookies === null || cookies === void 0 ? void 0 : cookies.lastEventTime, sessionTimeout),
    storageProvider: createEventsStorage(options),
    trackingOptions: __assign(__assign({}, defaultConfig.trackingOptions), options === null || options === void 0 ? void 0 : options.trackingOptions),
    transportProvider: (_c = options === null || options === void 0 ? void 0 : options.transportProvider) !== null && _c !== void 0 ? _c : createTransport(options === null || options === void 0 ? void 0 : options.transport)
  }));
};
export var createCookieStorage = function createCookieStorage(overrides, baseConfig) {
  if (baseConfig === void 0) {
    baseConfig = getDefaultConfig();
  }

  var options = __assign(__assign({}, baseConfig), overrides);

  var cookieStorage = overrides === null || overrides === void 0 ? void 0 : overrides.cookieStorage;

  if (!cookieStorage || !cookieStorage.isEnabled()) {
    cookieStorage = new CookieStorage({
      domain: options.domain,
      expirationDays: options.cookieExpiration,
      sameSite: options.cookieSameSite,
      secure: options.cookieSecure
    });

    if (options.disableCookies || !cookieStorage.isEnabled()) {
      cookieStorage = new LocalStorage();

      if (!cookieStorage.isEnabled()) {
        cookieStorage = new MemoryStorage();
      }
    }
  }

  return cookieStorage;
};
export var createEventsStorage = function createEventsStorage(overrides) {
  var eventsStorage = overrides === null || overrides === void 0 ? void 0 : overrides.storageProvider;

  if (!eventsStorage || !eventsStorage.isEnabled()) {
    eventsStorage = new LocalStorage();

    if (!eventsStorage.isEnabled()) {
      eventsStorage = new MemoryStorage();
    }
  }

  return eventsStorage;
};
export var createDeviceId = function createDeviceId(idFromCookies, idFromOptions, idFromQueryParams) {
  return idFromOptions || idFromQueryParams || idFromCookies || UUID();
};
export var createSessionId = function createSessionId(idFromCookies, idFromOptions, lastEventTime, sessionTimeout) {
  if (idFromCookies === void 0) {
    idFromCookies = 0;
  }

  if (idFromOptions === void 0) {
    idFromOptions = 0;
  }

  if (lastEventTime === void 0) {
    lastEventTime = 0;
  }

  if (idFromCookies && Date.now() - lastEventTime < sessionTimeout) {
    return idFromCookies;
  }

  return idFromOptions ? idFromOptions : Date.now();
};
export var createTransport = function createTransport(transport) {
  if (transport === TransportType.XHR) {
    return new XHRTransport();
  }

  if (transport === TransportType.SendBeacon) {
    return new SendBeaconTransport();
  }

  return getDefaultConfig().transportProvider;
};